import * as actionTypes from 'modules/audits/actionTypes';
import type { PayloadAction } from 'modules/global/generic.types';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** An audit start date, as returned by the API (ISO string). */
export type AuditStartDate = string | null;

export type AuditStartDateByAuditId = Record<string, AuditStartDate>;

type StartDatePayload = {
  id: string;
  startDate?: string | null;
};

export const initialState: AuditStartDateByAuditId = {};

const setStartDate = (
  state: AuditStartDateByAuditId,
  { payload }: PayloadAction<StartDatePayload>,
): AuditStartDateByAuditId => ({
  ...state,
  [payload.id]: payload.startDate ?? null,
});

const removeStartDate = (
  state: AuditStartDateByAuditId,
  { payload: auditId }: PayloadAction<string>,
): AuditStartDateByAuditId => {
  const { [auditId]: _removed, ...rest } = state;
  return rest;
};

const reset = (): AuditStartDateByAuditId => initialState;

const successHandlers = Object.fromEntries(
  actionTypes.SINGLE_AUDIT_SUCCESS_TYPES.map(type => [type, setStartDate] as const),
);

export default createReducer<AuditStartDateByAuditId>(initialState, {
  ...successHandlers,
  [actionTypes.DELETE_SUCCESS]: removeStartDate,
  [LOCATION_CHANGE]: reset,
});
